import {
  TAGS_ALL,
  TAGS_ALL_SUCCESS,
  TAGS_CREATE,
  TAGS_CREATE_SUCCESS,
  TAGS_DELETE,
  TAGS_DELETE_SUCCESS,
  TAGS_GET,
  TAGS_GET_SUCCESS,
  TAGS_UPDATE,
  TAGS_UPDATE_SUCCESS
} from "redux/constants/Tags"

export const getTags = () => {
  return {
    type: TAGS_ALL,
  }
}

export const getTagsSuccess = (tags) => {
  return {
    type: TAGS_ALL_SUCCESS,
    tags,
  }
}

export const getTag = (tagId) => {
  return {
    type: TAGS_GET,
    tagId,
  }
}

export const getTagSuccess = (tag) => {
  return {
    type: TAGS_GET_SUCCESS,
    tag,
  }
}

export const createTag = (data, history) => {
  return {
    type: TAGS_CREATE,
    data,
    history,
  }
}

export const createTagSuccess = (tag) => {
  return {
    type: TAGS_CREATE_SUCCESS,
    tag,
  }
}

export const updateTag = (tagId, data, history) => {
  return {
    type: TAGS_UPDATE,
    tagId,
    data,
    history,
  }
}

export const updateTagSuccess = (tagId, tag) => {
  return {
    type: TAGS_UPDATE_SUCCESS,
    tagId,
    tag,
  }
}

export const deleteTag = (tagId, history) => {
  return {
    type: TAGS_DELETE,
    tagId,
    history,
  }
}

export const deleteTagSuccess = (tagId) => {
  return {
    type: TAGS_DELETE_SUCCESS,
    tagId,
  }
}